export const api = {
  queryVisitorApplyRecordList: '/vas/appointment/queryVisitorApplyRecordList.json', //WEB页面访客预约记录列表查询接口
  queryVisitorApplyDetail: '/vas/appointment/queryAppointmentDetail.json', //预约详情查询接口
  queryAppointmentWorkflow: '/vas/appointment/queryAppointmentWorkflow.json',
  singleFlowDetail: '/vas/appointment/queryAppointmentWorkflowDetail.json',
  exportVisitorApplyRecordList: '/vas/appointment/exportVisitorApplyRecordList.json', //导出列表
  getRecordList: '/bms/vehiclebarrier/queryVehicleBarrierAuthorityRecordList.json', //车辆授权信息列表接口
  car: {
    getDetails: '/vas/appointment/queryAppointmentDetail.json',
    getWorkFlow: '/vas/appointment/queryAppointmentWorkflow.json'
  },
  config: {
    getTemplateField: '/vas/appointment/queryAppointmentTemplateFieldApi.json', //查询预约模板字段  
    updateTemplateField: '/vas/appointment/updateAppointmentTemplateField.json', //修改预约模板字段
  },
  queryPersonDevice: "/bms/personAuthorization/queryPersonDeviceAuthorization.json", //查询人员关联设备
  queryVehicleDevice: 'bms/vehiclebarrier/queryVehicleDevice.json', //车辆授权
  addVisitorApply: '/vas/appointment/addVisitorApply.json', //新增邀约
  addWeixinVisitorApply: '/vas/appointmentweixin/addVisitorApply.json',
  queryNameByPhone: '/vas/appointmentweixin/queryNameByPhone.json', //根据手机号查人
  getVisitorMyApplyList: 'vas/appointment/queryVisitorApplyRecordList.json',
  queryVisitorDetail: '/vas/appointment/queryAppointmentDetail.json',
  deleteVisitorApply: '/vas/appointment/deleteVisitorApply.json', //新增邀约
  queryVisitorApprovalPendingList: '/vas/appointment/queryVisitorApprovalPendingList.json', //待审批
  queryVisitorMyApprovalList: '/vas/appointment/queryVisitorMyApprovalList.json', //已审批
  doApprovalVisitor: '/vas/appointment/approvalVisitor.json', //审批
  getVisitorTypeListApi: '/vas/personnel/queryVisitorTypeList.json',
  queryPersonListApi: '/vas/personnel/queryPersonList.json', //查询员工
  queryDepotLotList: 'bas/queryVehicle/queryDepotLotList', //停车场
  delayedVisitorApply: '/vas/appointment/delayedVisitorApply.json', //延期
  isExistsPersonInfo: '/cms/check/currUserIsExistsPersonInfo.json', //查询当前帐号是否绑定人员库

  // queryAppointmentWorkflow: '/vas/appointment/queryAppointmentWorkflow.json'. //查询审批工作流
  //   getVisitorTypeListApi(param) {
  //     return request.fetch({
  //       url: 'vas/personnel/queryVisitorTypeList.json',
  //       data: param
  //     })
  //   },
}


// import request from '@/common/request/index.js'

// export default {
//   //预约流程
//   queryProcess(param) {
//     return request.fetch({
//       url: 'vas/appointment/queryAppointmentWorkflow.json',
//       data: param
//     })
//   },
//   //预约详情
//   queryDetail(param) {
//     return request.fetch({
//       url: 'vas/appointment/queryAppointmentDetail.json',
//       data: param
//     })
//   },
//   addVisitorApply(param) {
//     return request.fetch({
//       url: 'vas/appointment/addVisitorApply.json',
//       data: param
//     })
//   },
//   //我的访客申请列表
//   getVisitorMyApplyList(param) {
//     return request.fetch({
//       url: 'vas/appointment/queryVisitorApplyRecordList.json',
//       data: param
//     })
//   },
//   queryWeixinVehicleAuthority(param) {
//     return request.fetch({
//       url: '/vas/appointment/queryVehicleAuthority.json',
//       data: param
//     })
//   },
//   //根据手机号查人
//   queryNameByPhone(param) {
//     return request.fetch({
//       url: 'vas/appointment/queryNameByPhone.json',
//       data: param
//     })
//   },
//   queryVisitorApplyDetail(param) {
//     return request.fetch({
//       url: 'vas/appointment/queryAppointmentDetail.json',
//       data: param
//     })
//   },
//   //查询预约模板字段
//   queryAppointmentTemplateField(param) {
//     return request.fetch({
//       url: '/vas/appointment/queryAppointmentTemplateField.json',
//       data: param
//     })
//   },
//   // 查询视频播放路径
//   queryRealTimeVideoRtsp(param) {
//     param.streamType = 'SUB'
//     return request.fetch({
//       loadingTitle: "视频请求中",
//       url: 'vas/video/queryRealTimeVideoRtsp.json',
//       data: param
//     })
//   },
//   // 安保换岗的区域查询
//   queryTrafficArea() {
//     return request.fetch({
//       url: '/vas/appointment/queryTrafficArea.json',
//       data: {
//         parkId: '200000001',
//         isOutSide: '1'
//       }
//     })
//   },
//   // APP端访客待审批和车辆待审批统计数据
//   queryCountNumber() {
//     return request.fetch({
//       url: 'vas/appointment/queryApprovalPendingCount.json'
//     })
//   },
//   // 查询人员列表（访客、员工）
//   queryPersonnelVehicleList() {
//     return request.fetch({
//       url: 'vas/personnel/queryPersonnelVehicleList.json'
//     })
//   },
//   // 查询最新的App版本号

//   queryVisitorProcess(param) {
//     return request.fetch({
//       url: 'vas/appointment/queryAppointmentWorkflow.json',
//       data: param
//     })
//   },
//   // 获取人员通行权限
//   queryTurnstilegateRightGroupList(param) {
//     return request.fetch({
//       url: 'vas/appointment/queryTurnstilegateRightGroupList.json',
//       data: param
//     })
//   },
//   // 鲁南云 获取访客类型
//   getVisitorTypeListApi(param) {
//     return request.fetch({
//       url: 'vas/personnel/queryVisitorTypeList.json',
//       data: param
//     })
//   },
//   // 根据手机号码查询员工信息
//   queryLunanNameByPhone(param) {
//     return request.fetch({
//       url: 'vas/appointment/queryNameByPhone.json',
//       data: param
//     })
//   },
// }